import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Zap, Sparkles, FileSignature, Boxes, MapPin, Banknote, ShieldCheck,
  Presentation, X, ChevronRight, Star, Clock,
} from "lucide-react";

/**
 * Executive Quick Actions — floating action dock.
 * Each action deep-links to an existing capability. Presentation-only.
 */
const ACTIONS = [
  { key: "brief",       label: "Generate Cabinet Brief",   icon: FileSignature, to: "/app/gsros",                  accent: "#C99A2E" },
  { key: "presentation",label: "Launch Boardroom Mode",    icon: Presentation,   to: "/app/boardroom",             accent: "#7B2FBE" },
  { key: "twin",        label: "Open National Digital Twin",icon: Boxes,         to: "/app/twin",                  accent: "#4FA3D1" },
  { key: "map",         label: "Open Public Maps",         icon: MapPin,        to: "/portal/map",                accent: "#4FA3D1" },
  { key: "revenue",     label: "Open Revenue Ledger",      icon: Banknote,      to: "/app/revenue",               accent: "#4FA3D1" },
  { key: "compliance",  label: "Open Compliance",          icon: ShieldCheck,   to: "/app/compliance",            accent: "#6BB88A" },
  { key: "watchlist",   label: "Executive Watchlist",      icon: Star,          to: "/app/watchlist",             accent: "#C99A2E" },
  { key: "timeline",    label: "Executive Timeline",       icon: Clock,         to: "/app/timeline",              accent: "#4FA3D1" },
  { key: "ai",          label: "AI Executive Briefing",    icon: Sparkles,      to: "/app/gsros",                 accent: "#C99A2E" },
];

export const QuickActions = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="fixed bottom-6 right-6 z-[55]" data-testid="quick-actions">
      {open && (
        <div className="rounded-sm border border-[#C99A2E]/40 shadow-2xl mb-2 overflow-hidden"
             style={{ background: "linear-gradient(180deg, rgba(7,27,43,0.98), rgba(11,53,88,0.95))" }}>
          <div className="px-3 py-2 border-b border-white/10 flex items-center gap-2">
            <Zap size={12} className="text-[#C99A2E]" />
            <div className="font-mono uppercase tracking-[0.22em] text-[10px] text-[#C99A2E]">Executive quick actions</div>
            <button onClick={() => setOpen(false)} data-testid="quick-actions-close" className="ml-auto text-[#7C93A5]">
              <X size={12} />
            </button>
          </div>
          <div className="max-h-[400px] overflow-y-auto">
            {ACTIONS.map((a) => (
              <Link key={a.key} to={a.to}
                    data-testid={"quick-action-" + a.key}
                    onClick={() => setOpen(false)}
                    className="flex items-center gap-2.5 px-3 py-2 border-b border-white/5 text-[12px] text-[#F6F8FA]"
                    style={{ transition: "background 0.15s" }}>
                <a.icon size={13} style={{ color: a.accent }} />
                <div className="flex-1">{a.label}</div>
                <ChevronRight size={11} className="text-[#7C93A5]" />
              </Link>
            ))}
          </div>
        </div>
      )}
      <button onClick={() => setOpen((v) => !v)}
              data-testid="quick-actions-toggle"
              className="rounded-full shadow-2xl inline-flex items-center gap-2 px-4 py-3 border font-mono uppercase tracking-[0.16em] text-[11px]"
              style={{
                background: "linear-gradient(135deg, #C99A2E, #7B2FBE)",
                borderColor: "rgba(255,255,255,0.2)",
                color: "#F6F8FA",
              }}>
        <Zap size={13} /> Quick Actions
      </button>
    </div>
  );
};

export default QuickActions;
